let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3tiCD")).then(() => parcelRequire('imljT'));